<template>

  <hsc-window-style-metal class="bottom-right">
    <hsc-window ref="dragWindow" title="Videollamada" positionHint="-20 / -100"
                @move-start="blockPointerEvents = true" @move-end="blockPointerEvents = false"
                :resizable="true" :minWidth="350" :minHeight="230" :maxWidth="600" :maxHeight="230"
    >
      <div class="radial-gradient-1"></div>
      <kim-meet-client
          :style="{'pointer-events': blockPointerEvents ? 'none' : 'inherit'}"
          v-if="!!currentEvent"
          performance-mode
          :user="{displayName: currentUser && currentUser.first_name || defaultUser}"
          :room-id="currentEvent.vc_id"
          width="100%"
          height="230px"
          :controls="['camera', 'microphone', 'chat', 'desktop', 'fullscreen', 'settings', 'tileview']"
      />
    </hsc-window>
  </hsc-window-style-metal>

</template>

<script>

    import {mapState} from 'vuex'
    import {getLabel} from '@/utils/Institution'

    export default{
        components: {
            KimMeetClient: () => import('@/components/common/webRTC/KimMeetClient'),
        },
        data(){
            return {
              blockPointerEvents: false
            }
        },
        methods: {},
        computed:{
            ...mapState('clientAttention', {
                currentEvent: state => state.currentEvent,
                drawer: state => state.attentionSummaryDrawer

            }),
            ...mapState(['currentUser']),
            waitingForGuestLabel(){
                return `Esperando al ${getLabel('commons.client.singular').toLowerCase()}...`
            },
            defaultUser() {
                return 'Usuario ' + process.env.VUE_APP_NAME
            }
        },
    }
</script>

<style scoped>
    .container{
        position: absolute;
        top: 3px;
        left: 3px;
        cursor: pointer;
        border-radius: 5px;
        width: 20px;
        height: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        background-color: red;
        z-index: 10
    }

    .bottom-right {
        z-index: 2;
        position: fixed;
        /*right: 380px;*/
        /*bottom: 400px;*/
    }
</style>